export const calculateTotalPageCount = (
  totalCount: number,
  limit: number
): string => {
  return Math.ceil(totalCount / limit).toString()
}
